export const stringReplace = (string, token, replacement) =>
    string.replace(token, replacement);